if (!customElements.get('m-product-tabs')) {
  customElements.define(
    'm-product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();

        this.mainSlider = null;
        this.thumbnailSlider = null;
      }

      connectedCallback() {
        this.thumbnailEl = this.querySelector('.m-product-tabs__swiper-thums');
        this.mainEl = this.querySelector('.m-product-tabs__swiper-main');

        if (!this.thumbnailEl || !this.mainEl) return;
        this.initializeSwiper();
      }

      initializeSwiper() {
        this.thumbnailSlider = new Swiper(this.thumbnailEl, {
          slidesPerView: 3,
          spaceBetween: 0,
          centerInsufficientSlides: true,
          loop: false,
          breakpoints: {
            650: {
              slidesPerView: 'auto',
            },
          },
        });

        this.mainSlider = new Swiper(this.mainEl, {
          slidesPerView: 1,
          spaceBetween: 24,
          autoHeight: true,
          speed: 500,
          effect: 'fade',
          mousewheel: {
            forceToAxis: true,
            sensitivity: 1,
            releaseOnEdges: true,
          },
          fadeEffect: {
            crossFade: true,
          },

          thumbs: {
            swiper: this.thumbnailSlider,
          },
        });
      }
    },
  );
}
